module.exports = __webpack_public_path__ + "img/worksrbanner_img20021104.2c2de145.jpg";